import React, {Component, Fragment} from 'react';
import {showPublishingTeaserPopup} from "../../PublishingTeaser";

import {observer} from "mobx-react";
import PostMediaAttachments from "./PostMediaAttachments";
import AddPhotoVideoAttachment from "./AddPhotoVideoAttachment";
import AddLink from "./AddLink";
import {PostEditorFormFields} from "./formShapes";
import {FORM_MODE} from "../../../socialConstants";


@observer
export default class DefaultPost extends Component {

  static propTypes = PostEditorFormFields;

  render() {
    const { config, values, onChangeSetObject, showPublishingTeaser, mode } = this.props;
    const textContainerHeight = '200px';

    return <Fragment>
      <div className={`d-flex flex-column justify-content-between chatter-publish-textarea-container${!showPublishingTeaser ? '' : ' disabled'}`}
        onClick={() => { if (showPublishingTeaser) showPublishingTeaserPopup() }} >
        <div className="d-flex" style={{minHeight: textContainerHeight}}>
          <textarea
            className="form-control content-spacer-top flex-grow-1"
            style={{minHeight: textContainerHeight}}
            placeholder={config.textPlaceholder}
            value={values.text || ''}
            disabled={showPublishingTeaser || mode === FORM_MODE.VIEW}
            onChange={(e) => {
              onChangeSetObject({text: e.target.value})
            }}
          />
        </div>
        { config.canPublishImmediateReply &&
          <div className={`d-flex chatter-publish-textarea-container${!showPublishingTeaser ? '' : ' disabled'}`}
            style={{minHeight: textContainerHeight}}
            onClick={() => { if (showPublishingTeaser) showPublishingTeaserPopup() }} >

            <textarea
              className="form-control content-spacer-top"
              style={{minHeight: textContainerHeight}}
              placeholder="Enter your answer here ..."
              value={values.immediateReply || ''}
              disabled={!config.canPublishImmediateReply || mode === FORM_MODE.VIEW}
              onChange={(e) => {
                onChangeSetObject({immediateReply: e.target.value})
              }}
            />
          </div>
        }

        <div className="d-flex flex-column justify-content-between">
          {/* The spread operator is here as the expected props are the exact same as this form. */}
          <PostMediaAttachments {...this.props}/>
          { mode === FORM_MODE.EDIT && (
              <div className="d-flex flex-row justify-content-start mt-2">
                <AddPhotoVideoAttachment {...this.props}/>
                { this.props.config.canAttachLink && <AddLink {...this.props}/>}
              </div>
            )
          }
        </div>

      </div>

    </Fragment>
  }
}
